import { IEconomicsCalculationsAnnualValue } from '../../interfaces/ieconomics-calculations-annual-value';
import { Scenario } from '../scenario';
import { Well } from '../well';

export class EconomicsCalculationsAnnualValueBase {
  EconomicsCalculationsAnnualValueId: number;
  ScenarioId: number;
  WellId: number;
  Year: number | null;
  PV: number | null;
  AllInCapex: number | null;
  DiscountedCumulativeGain: number | null;
  DROI: number | null;
  CapitalEfficiency: number | null;
  PaybackPeriod: number | null;
  InternalRateOfReturn: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Scenario?: Scenario;
  Well?: Well;

  constructor(item?: IEconomicsCalculationsAnnualValue) {
    if (item) {

      this.EconomicsCalculationsAnnualValueId = item.EconomicsCalculationsAnnualValueId;
      this.ScenarioId = item.ScenarioId;
      this.WellId = item.WellId;
      this.Year = item.Year;
      this.PV = item.PV;
      this.AllInCapex = item.AllInCapex;
      this.DiscountedCumulativeGain = item.DiscountedCumulativeGain;
      this.DROI = item.DROI;
      this.CapitalEfficiency = item.CapitalEfficiency;
      this.PaybackPeriod = item.PaybackPeriod;
      this.InternalRateOfReturn = item.InternalRateOfReturn;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Scenario = new Scenario(item.Scenario);
      this.Well = new Well(item.Well);
    }
  }
}